<template>
    <v-dialog v-model="dialog" max-width="600" persistent>
        <v-card>
            <v-card-title class="text-h5 font-weight-bold text-darkblue pa-4">
                Créer une liste de contacts
            </v-card-title>

            <v-card-text class="pa-4">
                <div class="d-flex flex-column gap-3">
                    <div class="text-body-1">
                        Vous êtes sur le point de créer une liste contenant <strong>{{ contactsCount }}</strong>
                        contact{{ contactsCount > 1 ? 's' : '' }}.
                    </div>

                    <v-text-field v-model="listName" label="Nom de la liste *" density="comfortable"
                        placeholder="Ex: Participants 10km, Participants repas du samedi..." :rules="[rules.required]"
                        autofocus @keyup.enter="confirm"></v-text-field>
                </div>
            </v-card-text>

            <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <SportipsButton @onClick="cancel" outlined>
                    Annuler
                </SportipsButton>
                <SportipsButton @onClick="confirm" :disabled="!isValid" chevron icon="mdi-check">
                    Créer la liste
                </SportipsButton>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        contactsCount: {
            type: Number,
            required: true
        }
    },
    emits: ['update:modelValue', 'confirm'],
    data() {
        return {
            listName: '',
            rules: {
                required: value => !!value || 'Le nom de la liste est obligatoire',
            }
        }
    },
    computed: {
        dialog: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        },
        isValid() {
            return this.listName && this.listName.trim().length > 0;
        }
    },
    methods: {
        confirm() {
            if (this.isValid) {
                this.$emit('confirm', this.listName.trim());
                this.resetForm();
            }
        },
        cancel() {
            this.dialog = false;
            this.resetForm();
        },
        resetForm() {
            this.listName = '';
        }
    },
    watch: {
        dialog(newVal) {
            if (!newVal) {
                this.resetForm();
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>
